import React, { useState } from "react";

import { FolderMoreDrawer } from "@/components/blocks/search/folder-more-drawer/FolderMoreDrawer";
import { FullscreenDrawer } from "@/components/elements/fullscreen-drawer/FullscreenDrawer";
import { Box, IconButton, useTheme } from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowLeftIcon from "~public/icons/Arrow Left/Arrow Left.svg";

import RecipePan from "../../global/recipe-pan/RecipePan";

export const FolderDrawer = ({
  isOpen,
  handleClose,
  folder
}: any): JSX.Element => {
  const theme = useTheme();
  const [isMoreDrawerOpen, setIsMoreDrawerOpen] = useState<boolean>(false);

  const toggleMoreDrawer = (value: boolean) => {
    setIsMoreDrawerOpen(value);
  };

  const LeftButton = (
    <IconButton onClick={handleClose} id={"cart_top_nav__push_back"}>
      <ArrowLeftIcon />
    </IconButton>
  );

  const RightButton = (
    <IconButton
      sx={{ "& path": { fill: theme.palette.primary.main } }}
      onClick={() => toggleMoreDrawer(true)}
      id={"cart_top_nav__push_back"}>
      <MoreVertIcon />
    </IconButton>
  );

  return (
    <FullscreenDrawer
      isOpen={isOpen}
      handleClose={handleClose}
      title={folder?.name}
      leftButton={LeftButton}
      rightButton={RightButton}>
      <Box
        sx={{
          py: 3,
          px: 2,
          display: "flex",
          columnGap: 2,
          rowGap: 1,
          flexWrap: "wrap",
          justifyContent: "start",
          alignItems: "start",
          "&>:nth-of-type(odd)": {
            display: "flex",
            alignItems: "start"
          },
          "&>:nth-of-type(even)": {
            display: "flex",
            alignItems: "end"
          }
        }}>
        {/*@ts-ignore*/}
        {folder.recipes.map(({ content_object: recipe }) => (
          <Box
            flex={1}
            flexBasis={1 / 2}
            className="result_element"
            sx={{ height: 115 * 1.5, width: "min-content" }}
            key={recipe.pk}>
            <RecipePan key={recipe.pk} recipe={recipe} />
          </Box>
        ))}
      </Box>
      <FolderMoreDrawer
        isOpen={isMoreDrawerOpen}
        closeFolderDrawer={handleClose}
        toggleDrawer={toggleMoreDrawer}
        folder={folder}
      />
    </FullscreenDrawer>
  );
};
